import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';
import { PatientsTableCard } from '../../../containers/Cards';

const OrganizationView = () => (
  <Fade>
    <Container fluid className="mt-3">
      <Row>
        <Col>
          <PatientsTableCard></PatientsTableCard>
        </Col>
      </Row>
    </Container>
  </Fade>
);
export default OrganizationView;
